import React from "react";
import Page from "../components/Page";

const Terms = () => <Page title="Terms of Use">this is the Terms of use</Page>;

export default Terms;
